'use strict';

module.exports = {
  debug: false,   // 测试环境true，生产环境false，注意
  titles: {
    home: 'beat365手机版官网-国内领先的创新型金融科技企业',
    weTechnology: 'beat365手机版官网-创新金融服务,创造美好生活',
    weProduct: '好分期-beat365手机版官网旗下分期借款平台',
    weCulture: '企业文化-beat365手机版官网',
    weAbout: '关于我们-beat365手机版官网',
  },
  keywordsList: [
    'beat365手机版官网，beat365手机版官网，好分期',
    'werisk|wefund|weasset|微睿|微蜂|微安|风控管理系统|资金管理系统|资金管理平台',
    '分期贷款平台|小额贷款公司|小额贷款软件|分期借贷平台|借款平台排名|借款APP排名|好分期|好分期app|北京beat365手机版官网|beat365手机版官网',
    '企业文化|企业使命|企业愿景|北京beat365手机版官网|beat365手机版官网',
    '关于我们|联系我们|北京beat365手机版官网|beat365手机版官网'
  ],
  descriptionList: [
    'beat365手机版官网是国内领先的创新型金融科技企业,以“科技为本,创新金融服务,创造美好生活”为使命,凭借卓越的金融科技能力,长期积累的数据优势,致力于成为数千金融机构值得信赖的合作伙伴，同时通过好分期品牌为年轻的高成长用户提供信用借款/电商分期等消费金融服务。',
    '北京beat365手机版官网通过三大核心系统:智能风控引擎微睿(werisk)/资金管理平台微安(weasset)/资金管理系统微蜂(wefund)连接广大金融机构与数千万用户,提升金融机构资金利用效率.同时为用户提供更高效的资金服务,为beat365手机版官网金融科技生态体系安全运营保驾护航.',
    '好分期平台,隶属beat365-官方手机版网站-Official website,提供个人信贷业务,无需抵押,最高借款额度可达20万元,贷款APP就选好分期,支持提前还款,最快一分钟过审,好分期,值得信赖的专业贷款平台.',
    'beat365-官方手机版网站-Official website企业文化为科技为本,创新金融服务,创造美好生活.',
    'beat365手机版官网成立于2012年,目前已发展成为国内领先的创新型金融科技企业,想了解更多关于beat365手机版官网信息,可访问beat365手机版官网官网www.we.cn'],
};



// WEBPACK FOOTER //
// ./src/config.js